import { makeAutoObservable, runInAction } from "mobx";
import api from "../Utils/api";
import session from "../Utils/session";

class UserProfileStore {
  profile = null;

  loaded = false;

  constructor() {
    makeAutoObservable(this);
  }

  get following() {
    return this.profile && this.profile.followedBy.reduce((acc, f) => acc || f.username === session.getUsername(), false);
  }

  load(username) {
    this.profile = null;
    api.getUserProfile(username).then((res) => {
      runInAction(() => {
        this.profile = res;
        this.loaded = true;
      });
    }).catch(() => {
      runInAction(() => {
        this.loaded = true;
      })
    });
  }

  toggleFollow() {


    if (!this.following) {
      api.follow(this.profile.username).then(() => {
        runInAction(() => {
          this.profile.followedBy.push({ username: session.getUsername() });
        })
      })
    } else {
      api.unfollow(this.profile.username).then((res) => {
        runInAction(() => {
          this.profile.followedBy = this.profile.followedBy.filter(f => f.username !== session.getUsername());
        })
      })
    }
  }
}

const userProfileStore = new UserProfileStore();
export default userProfileStore;
